export enum DataHooks {
  Layout = 'daily-agenda-weekly-picker-layout',
}
